import { Supervisor } from '../../domain/supervisor/Supervisor';
import { SupervisorsTableColumn } from './tableColumns';

export enum SupervisorActionType {
  SEARCH_SUPERVISORS_SUCCESS = `SEARCH_SUPERVISORS_SUCCESS`,
  SET_SUPERVISORS_TABLE_COLUMNS = `SET_SUPERVISORS_TABLE_COLUMNS`,
}

export interface SearchSupervisorSuccessAction {
  type: SupervisorActionType.SEARCH_SUPERVISORS_SUCCESS;
  payload: {
    supervisors: Supervisor[];
  };
}

export interface SetSupervisorsTableColumnsAction {
  type: SupervisorActionType.SET_SUPERVISORS_TABLE_COLUMNS;
  payload: Array<SupervisorsTableColumn>;
}

export type SupervisorActions = SearchSupervisorSuccessAction | SetSupervisorsTableColumnsAction;
